import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const leanTestComponent: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'wixui_LeanTestComponent_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'LeanTestComponentRole',
      bindings: [
        {
          title: 'wixui_LeanTestComponent_dataBinding_label_label',
          prop: 'label',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.richText,
            FieldType.email,
          ],
          defaultFieldType: FieldType.text,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
